<template>
    <div class="cart__item-quantity">
        <div class="cart__item-quantity-btn minus" v-on:click="qtyDec($event)">&#8210;</div>
        <input type="text" name="quantity"
               :value="cart_qty"
               v-on:change="changeQty($event, $event.target.value)"
        />
        <div class="cart__item-quantity-btn plus" v-on:click="qtyInc($event)">+</div>
    </div>
</template>

<script>
    export default {
        name: "cart-item-quantity",
        props: ['cart_item_id'],
        data () {
            return {
                cart_item_idLocal: this.cart_item_id,
                target: ''
            }
        },
        computed: {
            cart_qty () {
                const cart_items = this.$store.getters.cartitems;
                let product =cart_items.filter((item) => {
                    return item.id===this.cart_item_idLocal;
                });
                return product[0].qty;
            }
        },
        watch: {
            cart_qty () {
                this.target.style.backgroundColor ='#fff';
            }
        },
        methods: {
            qtyInc (elem) {

                let qty = this.cart_qty;
                qty++;
                this.changeQty(elem, qty);

            },
            qtyDec (elem) {

                let qty = this.cart_qty;
                qty--;
                this.changeQty(elem, qty);
            },
            changeQty (elem, qty) {
                this.target = elem.currentTarget
                this.target.style.backgroundColor ='#ddd';

                if(qty < 1) {
                    qty = 1;
                }

                this.$store.dispatch('changeProductQty', {qty: qty, cart_item_id: this.cart_item_idLocal})
            }
        }
    }
</script>

<style scoped>

</style>